import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Box } from "@mui/material";
import { StatCardContainer, StatTableContainer } from "./containers";
import { useIsAuthenticatedEmployee } from "./hooks";

const rootContainerStyles = {
  maxHeight: "100vh",
  overflowY: "auto",
  alignItems: "space-around",
};

export const Root = () => {
  const queryClient = new QueryClient();

  const IsNotAuthenticatedUser = () => {
    return <>User not authenticated properly. Tip: Access this page via proper login channels. dash</>;
  };

  if (!useIsAuthenticatedEmployee()) {
    return <IsNotAuthenticatedUser />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Box sx={rootContainerStyles}>
        <StatCardContainer />
        <StatTableContainer />
      </Box>
    </QueryClientProvider>
  );
};
